import { STATES } from '../../../constants';

export const sexValues = ['Female', 'Male'] as const;
export type Sex = (typeof sexValues)[number];

export const phoneTypeValues = ['mobile', 'home', 'work'] as const;
export type PhoneType = (typeof phoneTypeValues)[number];

export const stateValues = [...Object.values(STATES)] as const;
export type State = (typeof stateValues)[number];

export enum TherapyIndication {
  ActivePsoriaticArthritis = 'Active Psoriatic Arthritis',
  ModerateToSeverePlaquePsoriasis = 'Moderate to Severe Plaque Psoriasis',
  ModeratelyToSeverelyActiveCrohnsDisease = "Moderately to Severely Active Crohn's Disease",
  ModeratelyToSeverelyActiveUlcerativeColitis = 'Moderately to Severely Active Ulcerative Colitis',
}
export const therapyIndicationValues = [
  TherapyIndication.ActivePsoriaticArthritis,
  TherapyIndication.ModerateToSeverePlaquePsoriasis,
  TherapyIndication.ModeratelyToSeverelyActiveCrohnsDisease,
  TherapyIndication.ModeratelyToSeverelyActiveUlcerativeColitis,
];
